/**
 * Format phone number to E.164 format (+1XXXXXXXXXX)
 * @param value - Phone number in any format
 * @returns Formatted phone number with +1 prefix
 */
export const formatPhoneNumber = (value: string): string => {
  if (!value) return '';
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // If empty after cleaning, return empty
  if (!digits) return '';
  
  // If starts with 1, assume it's US/Canada with country code
  if (digits.startsWith('1')) {
    return '+' + digits;
  }
  
  // Otherwise, add +1 prefix for US/Canada
  return '+1' + digits;
};

/**
 * Validate E.164 phone number format
 * @param value - Phone number to validate
 * @returns True if valid E.164 format
 */
export const isValidE164PhoneNumber = (value: string): boolean => {
  if (!value) return false;
  // E.164 format: +[country code][number] (max 15 digits total)
  return /^\+[1-9]\d{1,14}$/.test(value);
};
